import React from "react";

const ProductAndNewsEvent = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      className={props.className || ""}
      style={{fontSize: props.fontSize || "20px", pointerEvents: props.pointerEvents || "none"}}
    >
      <circle
        cx="20"
        cy="20"
        r="18"
        strokeWidth="2"
        fill="none"
      />
      <text
        x="50%"
        y="40%"
        textAnchor="middle"
        fontSize="24"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        dy=".35em"
      >
        p
      </text>
    </svg>
  );
};

export default ProductAndNewsEvent;
